"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var localizers_1 = require("../util/localizers");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
function isValid(d) {
    return !isNaN(d.getTime());
}
function formatDate(date, format, locale) {
    var val = '';
    if ((date instanceof Date) && isValid(date)) {
        val = localizers_1.date.format(date, format, locale);
    }
    return val;
}
// TODO: Fix this to use rest params instead of arguments.
function chain(a, b, thisArg) {
    return function () {
        // eslint-disable-next-line prefer-rest-params
        a && a.apply(thisArg, arguments);
        // eslint-disable-next-line prefer-rest-params
        b && b.apply(thisArg, arguments);
    };
}
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this._needsFlush = false;
        _this._change = function (e) {
            _this.setState({ textValue: e.target.value });
            _this._needsFlush = true;
        };
        _this._blur = function (e) {
            var val = e.target.value;
            var date;
            if (_this._needsFlush) {
                _this._needsFlush = false;
                date = _this.props.parse(val);
                _this.props.onChange(date, formatDate(date, _this.props.format, _this.props.locale));
            }
        };
        _this.focus = function () {
            ReactDOM.findDOMNode(_this).focus();
        };
        var text = formatDate(props.value, props.editing && props.editFormat ? props.editFormat : props.format, _this.props.locale);
        _this.startValue = text;
        _this.state = {
            textValue: text
        };
        return _this;
    }
    DateInput.prototype.componentWillReceiveProps = function (nextProps) {
        var text = formatDate(nextProps.value, nextProps.editing && nextProps.editFormat ? nextProps.editFormat : nextProps.format, nextProps.locale);
        this.startValue = text;
        this.setState({
            textValue: text
        });
    };
    DateInput.prototype.render = function () {
        var _a = this.props, id = _a.id, autoFocus = _a.autoFocus, role = _a.role, autoComplete = _a.autoComplete, placeholder = _a.placeholder, name = _a.name, tabIndex = _a.tabIndex;
        var value = this.state.textValue;
        var elementProps = _1.omit(this.props, Object.keys(DateInput.propTypes));
        return (React.createElement("input", __assign({ id: id }, elementProps, { autoFocus: autoFocus, role: role, autoComplete: autoComplete, placeholder: placeholder, name: name, type: "text", tabIndex: tabIndex, className: vdl_prefix_1.vdlPrefix('date-time-picker__input'), value: value, "aria-disabled": this.props.disabled, "aria-readonly": this.props.readOnly, disabled: this.props.disabled, readOnly: this.props.readOnly, onChange: this._change, onBlur: chain(this.props.blur, this._blur, this) })));
    };
    DateInput.propTypes = {
        id: PropTypes.string,
        format: PropTypes.any.isRequired,
        editFormat: PropTypes.any,
        parse: PropTypes.func.isRequired,
        value: PropTypes.instanceOf(Date),
        onChange: PropTypes.func.isRequired,
        locale: PropTypes.string,
        editing: PropTypes.bool,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        blur: PropTypes.func,
        textValue: PropTypes.string,
        autoFocus: PropTypes.bool,
        role: PropTypes.string,
        autoComplete: PropTypes.oneOf(['on', 'off']),
        placeholder: PropTypes.string,
        name: PropTypes.string,
        tabIndex: PropTypes.number
    };
    DateInput.defaultProps = {
        textValue: '',
        parse: function () { },
        format: '',
        onChange: function () { }
    };
    return DateInput;
}(React.Component));
exports.DateInput = DateInput;
